export default {
  'en-us': {
    flag: 'united_states',
    shopManagement: 'Store Manager',
    estimatedPaymentAmount: 'Expected payment amount',
    common: {
      search: 'Search',
    },
    footer: {
      address: 'Ergosleep Building 3F, Nonhyeon-ro 721 Gangnam-gu, Seoul, Korea',
      customerService: 'Customer Service 822-1577-0564',
      companyNameKorean: 'B1SOFT CO.,LTD',
      companyCeoName: 'CEO: Choi Seok Woong',
      businessLicenseNumberText: 'Business License Number',
      businessLicenseNumber: '816-87-01138',
      companyNameEnglish: 'B1SOFT., LTD B1SOFT',
    },
    currency: {
      kr: {
        text: 'KRW',
        symbol: '₩',
      },
      us: {
        text: 'USD',
        symbol: '$',
      },
    },
    grade: {
      Rookie: 'Rookie',
      Beginner: 'Beginner',
      Amateur: 'Amateur',
      SemiPro: 'SemiPro',
      Pro: 'Pro',
      TourPro: 'TourPro',
      Challenger: 'Challenger',
    },
    gender: {
      man: 'Male',
      woman: 'Female',
      unLimit: 'Other',
    },
    menu: {
      shopInfoManagement: 'Store Info Management',
      gameRoundOptionOptionManagement: 'Round option management',
      drivingRangeOptionOptionManagement: 'Driving Range Option Management',
      realtimeControlOptionManagement: 'Realtime Option Management',
      agreement: 'Terms and Conditions',
      signOut: 'Log Out',
    },
    signIn: {
      id: 'ID',
      password: 'PASSWORD',
      forgotId: 'Forgot Id',
      forgotPassword: 'Forgot Password',
      rememberMe: 'Remember Me',
      buttonSignIn: 'Sign In',
      cookie: 'Delete Cookies',
      cookieMessage: 'Cookies have been deleted.',

      fail: 'Login failed. Please try again.',
    },
    notification: {
      title: 'Notification',
      no: 'No.',
      roomName: 'Client Name',
      callTime: 'Call Time',
      message: 'Message',
      confirm: 'Confirm',
      noNotificationMSG: 'No assistance requests at this time.',

      billing_automatic_payment_failed: '[K-Golf Automatic Payment Failure Notice] Your K-Golf automatic payment has failed. You will not be able to access any content except the practice range after ${payment_date}. Please contact customer support for payment issues or further assistance. [Customer Support] ${customer_center_number}',
      billing_automatic_payment_guide: '[K-Golf Automatic Payment Reminder] Your K-Golf automatic payment is scheduled for ${payment_date}. Please ensure your account is in good standing. If the payment is not completed on the scheduled date, you will lose access to content other than the practice range after the due date. [Customer Support] ${customer_center_number}',
      billing_automatic_payment_success: '[K-Golf Payment Confirmation] Your K-Golf automatic payment has been successfully processed.',
      billing_content_restrictions_notice: '[K-Golf Usage Restriction Notice] Your payment was not completed by the due date. Access to content other than the practice range will be restricted starting from ${payment_date}. For payment and further assistance, please contact customer support. [Customer Support] ${customer_center_number}',
      billing_manual_payment_guide: '[K-Golf Manual Payment Period Notice] Your payment period is from ${start_date} to ${end_date} (${diff_day} days). If payment is not made within this period, you will not be able to access any content except the practice range after the due date. [Customer Support] ${customer_center_number}',

      game_client_additional_access_game_round_approval_failed: 'Failed to approve additional round access for ${client_name}.',
      game_client_additional_access_game_round_request: '${client_name} has requested additional round access.',
      game_client_additional_access_game_round_request_reject: 'The additional round access request from ${client_name} has been denied.',

      game_client_cancel_shot_failed: 'Failed to cancel the last shot for ${client_name}.',
      game_client_cancel_shot_failed_2: 'The player has used all available shot cancellations.',
      game_client_cancel_shot_failed_3: 'The game is in progress. Failed to cancel the shot.',
      game_client_cancel_shot_failed_4: 'No shots available for cancellation.',
      game_client_cancel_shot_success: 'The last shot for ${client_name} was successfully canceled.',

      game_client_extended_wait_success: '${client_name} has been placed in waiting mode.',

      game_client_force_disconnection_failed: 'Failed to disconnect ${client_name}.',
      game_client_force_disconnection_success: '${client_name} has been successfully disconnected.',

      game_client_guest_login_failed: 'Guest login for ${client_name} has failed.',
      game_client_guest_login_success: 'Guest login for ${client_name} was successful.',

      game_client_limit_change_failed: 'Failed to send the control option changes for ${client_name}.',
      game_client_limit_change_success: 'Control options for ${client_name} have been updated.',

      game_client_lock_failed: 'Failed to lock ${client_name}.',
      game_client_lock_success: '${client_name} has been locked.',

      game_client_player_count_change_failed: 'Failed to change the player count for ${client_name}.',
      game_client_player_count_change_request_reject: 'The request from ${client_name} to change the player limit was denied.',
      game_client_player_count_change_success: 'The player count for ${client_name} has been changed from ${n} to ${player_count}.',

      game_client_reset_mulligan_failed: 'Failed to reset the mulligan count for ${client_name}.',
      game_client_reset_mulligan_success: 'The mulligan count for ${client_name} has been successfully reset.',

      game_client_shop_manager_call_request: '${client_name} has requested assistance.',

      game_client_time_extension_failed: 'Failed to extend playtime for ${client_name}.',
      game_client_time_extension_request: '${client_name} has requested a playtime extension.',
      game_client_time_extension_request_reject: 'The playtime extension request from ${client_name} was denied.',
      game_client_time_extension_success_1: '${add_time} minutes have been added to ${client_name}\'s playtime.',

      game_client_unlock_failed: 'Failed to unlock ${client_name}.',
      game_client_unlock_success: '${client_name} has been unlocked.',

      game_client_user_login_failed: 'User login for ${client_name} has failed.',
      game_client_user_login_success: 'User login for ${client_name} was successful.',

      kms_notice: '${title}',

      quit_game_client_failed: 'Failed to process the quit request for ${client_name}.',
      quit_game_client_success: 'The quit request for ${client_name} was successful.',

      run_game_client_failed: 'Failed to start the game for ${client_name}.',
      run_game_client_success: 'The game for ${client_name} has started successfully.'
    },
    dashboard: {
      content: 'DashBoard',
    },
    gameHistory: {
      searchPeriod: 'Date Range',
      userNickname: 'User Nickname',
      userNicknamePlaceholder: 'Enter user nickname',
      search: 'Search',
      gameType: 'Game Type',
      shopClient: 'Client Name',
      all: 'All',
      gameHistoryStatistics: 'Game History Statistics',
      gameHistoryStatisticsNoticeText: '( Game History Statistics by search )',
      gameMode: 'Game Mode',
      normalGame: 'Normal Game',
      drivingRange: 'Driving Range',
      swingDiagnosis: 'Swing Diagnosis',
      userType: 'Player Type',
      user: 'Player',
      guest: 'Guest',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      times: 'Times',
      gameRoundList: 'Game Round List',
      gameNumbers: 'Round ID',
      clientName: 'Bay',
      numberPlayers: 'Players Count',
      numberHolesCompleted: 'Completed Holes',
      startDate: 'Start Time',
      endDate: 'End Time',
      more: 'More',
      close: 'Close',
      download: 'Download',
      alert: {
        message1: 'Please select at least one bay.',
        message2: 'Please select at least one game type.',
        message3: 'The period can be selected for up to 3 months.',
        message4: 'The download may be delayed depending on the amount of data. Do you want to continue?',
        message5: 'No data available.',
      },
    },
    clientStatus: {
      sendMessage: 'Send Message',
      statusInfo: 'Status Information',
      proceeding: 'In Progress',
      endUse: 'Game End',
      blind: 'Lock',
      lobby: 'Lobby',
      clientOff: 'Program off',
      course: 'Course',
      playerCount: 'Player Count',
      remainingTime: 'Remaining',
      start: 'Start',
      paymentType: 'Payment Method',
      usageModeSetting: 'Game Mode',
      gameType: 'Game Type',
      usageTimeSetting: 'Time',
      holeType: 'Hole Type',
      drivingRangeTime: 'Usage time on Driving Range',
      noLimit: 'No Limit',
      stroke: 'Stroke',
      drivingRange: 'Driving Range',
      minutes: ' min',
      lessThanMinute: 'Less than 1 min',
      paymentProgress: 'In Progress (Pay Later)',
      peopleCount: ' Players',
      noDrivingRange: 'None',
      status: 'Status',
      usageTime: 'Duration',
      usageCourse: 'Course',
      usagePeopleCount: 'Players',
      addGuest: 'Add Guests',
      extendedTime: 'Extend Time',
      scorecard: 'Scorecard',
      changeSetting: 'Change Settings',
      resetMulligan: 'Reset Mulligan',
      cancelShot: 'Shot Cancel',
      bilnd: 'Lock',
      currentHole: 'Current Hole',
      sound : 'Sound',
      clientType : 'Bay Type',
      popup: {
        close: 'Close',
        addGuest: {
          addGuest: 'Add Guest',
          guestNicknamePlaceholder: 'Enter guest nickname',
          cancel: 'Cancel',
        },
        shotCancel: {
          confirmMessage: '${clientName}\'s final shot at the bay will be canceled.',
          shotCancel: 'Confirm',
          cancel: 'Cancel',
        },
        sendMessage: {
          sendMessage: 'Send Message',
          all: 'ALL',
          cancel: 'Cancel',
          messagePlaceholder: 'Enter your message',
        },
        extendedTime: {
          extendedTime: 'Extended Time',
          minutes: 'min',
          addServiceTime: 'Add Service Time',
          cancel: 'Cancel',
        },
        changeSetting: {
          changeSetting: 'Change Settings',
          cancel: 'Cancel',
        },
      },
      alert: {
        message1: 'Please select a payment method',
        message2: 'Please select a usage time',
        message3: 'Please select the usage mode',
        message4: 'Please select a game type',
        message5: 'Please select a hole type',
        message6: 'Please select the number of players',
        message7: 'Please select a practice time',
        message8: 'Do you want to lock the bay screen?',
        message9: 'Please try again later',
        message10: 'Do you want to initialize the mulligan of the current game?',
        message11: 'Unable to request Mulligan initialization because there is no game round ID information.',
        message12: 'Do you want to change bay control settings?',
        message13: 'Do you want to change the game round settings?',
        message14: 'Select the bay to send the message.',
        message15: 'Please enter a message',
        message16: 'The bay cannot be extended because it is a deferred payment.',
        message17: 'Please select a time to extend again',
        message18: 'Type in guest nickname',
        message19: 'The guest login request cannot be made due to insufficient number of people who can log in.',
        message20: 'Unable to process the shot cancellation request as the game round ID information is missing.',
        
        message1000: 'The game round setting change function is being prepared',
      },
    },
    billing: {
      tossPay: {
        addressTitle: 'Shipping address',
        clearAddressButton: 'Clear address',
        clearAddressTooltip: 'Keep recipient/phone, clear address only',
        recipientPlaceholder: 'Recipient',
        phonePlaceholderKrw: 'Phone (e.g., 010-1234-5678)',
        phonePlaceholderIntl: 'Phone (country code allowed)',
        postcode: 'Postal code',
        searchAddressButton: 'Find address',
        address1Krw: 'Primary address',
        address2Krw: 'Detail address (Dong/Unit)',
        address1Intl: 'Address line 1',
        searchHint: 'Search…',
        address2Intl: 'Address line 2 (Apt, Unit, etc.)',
        country: 'Country',
        city: 'City',
        state: 'State / Province / Region',
        postalIntl: 'Postal code / ZIP',
        saveNoteKrw: '※ Shipping address will be saved with payment.',
        saveNoteIntl: '※ Your shipping address will be saved with your payment.',
        fedexTitle: 'FedEx Account',
        fedexPlaceholder: 'Enter your FedEx account number',
        fedexNote: '※ Required for collect (recipient-billed) shipments.',
        // ▼ added
        fedexHelpTitle: 'Don’t have a FedEx account?',
        fedexHelpDesc: 'Create one using the links below.',
        fedexGlobalLink: 'Open FedEx Account (Global)',
        fedexUSLink: 'Open FedEx Account (US)',
        fedexGuideLink: 'How do I create a FedEx account? (FAQ)',
        paymentMethodsTitle: 'Payment method',
        agreeRequired: 'You must agree to the Terms of Service and Privacy Policy.',
        enterShipping: 'Please enter your shipping address.',
        enterFedex: 'Please enter your FedEx Account.',
        payNow: 'Pay now',
        cardLabel: 'Credit Card',
        paypalLabel: 'PayPal',
        alipayLabel: 'Alipay',
      }
      ,
      paymentInfo: {
        ownerDefaultInfo: 'Store Owner Information',
        shopName: 'Store Name',
        shopOwnerName: 'Owner Name',
        shopAddress: 'Store Address',
        shopAddressChangeNoticeText: 'To update the store address, please contact K-Golf Customer Support.',
        receiveBillInfoChange: 'Change Billing Information',
        receiveBillInfoChangeNoticeText: 'Receive a monthly statement of charges for K-Golf services.',
        shopOwnerMobilePhone: 'Owner Phone Number',
        editButton: 'Edit',
        mobileBill: 'Mobile Billing Statement (MMS)',
        mobileBillNoticeText: 'A monthly billing statement will be sent to the store owner’s registered contact number.',
        sendButton: 'Send',
        shipsFirstDayEveryMonth: 'Sent on the 1st of each month',
        mobileBillNoAuth: 'Not authenticated. Mobile authentication is required to receive payment-related statements.',
        shopOwnerEmail: 'Owner Email Address',
        authenticateButton: 'Authenticate',
        emailBill: 'Email Billing Statement',
        emailBillNoticeText: 'A monthly billing statement will be sent to the store owner’s registered email address.',
        emailBillNoAuth: 'Not authenticated. Email authentication is required to receive payment-related statements.',
      },
      recurringPayment: {
        noRecurringPaumentServiceNoticeText1: 'Not Registered for Recurring Payment Service',
        noRecurringPaumentServiceNoticeText2: 'Recurring payment management is accessible only when the recurring payment service is registered.',
        agreementToUseRecurringPaymentService: 'Terms and Conditions for Recurring Payment',
        guide: 'Recurring payment service registration guide',
        whatIsRecurringPaymentService: 'What is a Recurring Payment Service?',
        recurringPaymentServiceDescription:
          'This service automatically deducts the payment amount each month on the date specified by K Golf Co., Ltd. headquarters. Using the automatic payment service provides a 2.0% discount on the maximum payment amount.',
        agreeTermsConditionsRecurringPayment: 'Agree to terms and conditions for periodic payment',
        allAgreement: 'Agree to All Terms',
        required: 'Required',
        termsOfRecurringPaymentService: 'Terms of Recurring Payment Service',
        personalInformationProvidedThirdParties: 'Consent to Share Personal Information with Third Parties',
        entrustingHandlingOfPersonalInformation: 'Consent to Delegate Personal Information Handling',
        useAgreementButtonText: 'Accept Agreement',
        useAgreementNoticeText: 'Use agreement notice text',
        recurringPaymentService: 'Recurring payment service',
        status: 'Status',
        statusApplyingText: 'Status applying',
        statusUseText: 'Status in use',
        serviceStartDate: 'Service start date',
        automaticPaymentDueDate: 'Automatic payment due date',
        discountRate: 'Discount rate',
        recurringPaymentServiceCancel: 'Recurring payment service cancel',
        bankAccountRegistrationAndManagement: 'Bank account registration and management',
        bankAccount: 'Bank account',
        bankAccountNumber: 'Bank account number',
        bankAccountName: 'Bank account name',
        management: 'Management',
        addBankAccount: 'Add bank account',
        deleteBankAccount: 'Delete bank account',
        noBankAccountNoticeText: 'There is no registered account.<br /> Please click the account registration button on the right to proceed with account registration.',
        creditCardRegistrationAndManagement: 'Card registration and management',
        creditCard: 'Credit Card',
        creditCardNumber: 'CreditCard Number',
        noCreditCardNoticeText: 'There is no registered card.<br />Please click the card registration button on the right to proceed with card registration',
        addCreditCard: 'Card registration',
        deleteCreditCard: 'Delete card',
        recurringPaymentNoticeText: 'If both an account and a card are registered in the automatic payment service,<strong style={{color:"#333333"}}>the account is given priority to the payment service</strong><br />If the amount available for withdrawal is insufficient in the account, we attempt to pay with a credit card.',
      },
      paymentProgress: {
        text1: 'Payment information is being checked',
        text2: 'Please wait.',
      },
      paymentComplete: {
        text1: 'Payment success',
        text2: '',
        buttonText: 'Complete',
      },
      paymentFail: {
        text1: 'Payment failure',
        text2: '(For virtual account payments, the service is available after the deposit is confirmed.)',
        buttonText: 'Close',
      },
      paymentCancel: {
        text1: 'Cancel payment',
        text2: '',
        buttonText: 'Close',
      },
      payment: {
        generalPayment: 'General Payment',
        prepayment: 'Advance Payment for Upcoming Charges',
        paymentUnpaidCharges: 'Payment for Outstanding Charges',

        chargesText: 'The amount due is <span class="price">|charges|</span> <span style="font-size:26px;">|currency|</span>',
        checkPaymentHistory: 'Please review your payment history.',
        billingMonth: 'Billing Month',
        amountBePaid: 'Total Charges',
        details: 'Details',
        choosePaymentMethod: 'Choose Payment Method',
        realTimeAccountTransfer: 'Bank Transfer',
        creditCardPayment: 'Credit Card Payment',

        tab1: {
          text1: 'Currently, it is not within the general payment period, or',
          text2: 'there is no outstanding amount to be paid.',
          text3: 'General Payment Period',
          text4: 'General payments are available only from the 1st of each month until the due date set by K-Golf.',
          text5: 'Payment Due Date',
          text6: 'General Payment Availability',
          text7: 'Monthly',
          text8: 'Date',
        },
        tab2: {
          text1: 'Currently, it is not within the advance payment period, or',
          text2: 'there is no amount available for advance payment.',
          text3: 'Advance Payment Period',
          text4: 'Advance payments are available only from the 1st of each month until two days prior to the due date set by K-Golf.',
          text5: 'Payment Due Date',
          text6: 'General Payment Availability',
          text7: 'Monthly',
          text8: 'Date',
        },
        tab3: {
          text1: 'There are no outstanding unpaid charges.',
          text2: 'Payments for unpaid charges can be made after the payment due date set by K-Golf.',
          text3: 'K-Golf Payment Due Date',
          text4: 'Monthly',
          text5: 'Date',
          text6: 'Advance Payment Availability',
          text7: 'Advance payments are available only from the 1st of each month until two days prior to the due date set by K-Golf.',
          text8: 'Payment Due Date',
          text9: 'Advance Payment Period',
        },
      },
      bills: {
        monthPaymentAmount: '|month| Payment Amount',
        usagePeriod: 'Usage Period',
        clientName: 'Bay Name',
        usageAmount: 'Usage Amount',
        discountAmount: 'Discount Amount',
        paymentAmount: 'Amount Due',
        contentPlan: 'Content Plan',
        coursePlan: 'Course Plan',
        minutes: 'Minutes',
        course: 'Course',
        totalCharges: 'Subtotal',
        count: 'Quantity',
        coutseUnlimit: 'Unlimited',
        vat: 'VAT',
        currentMonthTotalCharges: 'Total Charges for This Month',
        totalAmount: 'Total Amount Due',
      },
      paymentHistory: {
        text1: 'You can view up to 12 months of previous payment records. For records older than this period, please contact our support team.',
        billMonth: 'Invoice Date',
        charges: 'Total Charges',
        paymentStatus: 'Payment Status',
        paymentSuccess: 'Paid',
        unpayment: 'Unpaid',
      },
      itemPaymentHistory: {
        info01: 'Please check your email for the receipt associated with your item purchase. ',
        info02: 'For refund requests, contact customer support.',
        date: 'Purchase Date',
        orderNumber: 'Order Number',
        purchaseItem: 'Item Purchased',
        charges: 'Transaction Amount',
        paymentMethod: 'Payment Method',
        materialCode: 'Material Code',
        quantity:     'Quantity',
        paymentMethods: {
          CA:              'Credit Card',
          AccountTransfer: 'Account Transfer',
          PZ:              'PayZ',
          EASYPAY:         'Easy Pay',
        },
        statuses: {
          0: 'Preparing',
          1: 'Shipped',
          2: 'Delivered',
          3: 'Refunded',
        },
      },
    },
    customerService: {
      notice: {
        postType: 'Type',
        searchPlaceholder: 'Search',
        postTitle: 'Title',
        registrationDate: 'Registration Date',
        attachments: 'Attachments',
        moveListButtonText: 'List',
        postTypeCode: {
          notice: 'Notice',
          update: 'Update',
          event: 'Event',
        },
      },
      qna: {
        test: 'Test',
      },
    },
    edit: {
      shopInfoSetting: {
        clientTypeAlert: 'At least one bay type must be checked.',

        shopInfo: 'Store Information',
        shopName: 'Store Name',
        shopPhoneNumber: 'Store Phone',
        shopAddress: 'Store Address',
        shopOwnerName: 'Store Owner Name',
        shopOwnerMobilePhone: 'Store Owner Mobile Phone',

        shopSalesInfo: 'Store Sales Information',
        operatingTime: 'Manage time',
        operatingTimePlaceholder: 'Ex) \nWeekdays from 08:00 AM to 12:00 PM \nWeekends/Public Holidays from 06:00 AM to 12:00 PM',
        screen: 'Screen',
        practiceRange: 'Driving Range',
        lesson: 'Lesson',
        convenientFacilities: 'Amenities',
        swingPlate: 'Swing Plate',
        leftHanded: 'Dual-Handed Bays',
        parking: 'Parking',
        equipmentStorage: 'Equipment Storage',
        proLesson: 'Pro Lessons',
        fee: 'Fees',
        feePlaceholder: 'Ex) \nPlease contact the store for detailed charges',
        storeView: 'Store View',
        parkingNotice: 'Parking Information',
        parkingPlaceholder: 'Ex) \n Free parking (Use building parking)',
        storeIntroduce: 'Store Introduction',
        storeIntroducePlaceholder: 'Ex) \nWe strive to make golf enjoyable and accessible for everyone. \nThank you for your continued support and for choosing us!',
        clientList: 'Bay List',
        clientName: 'Bay Name',
        clientOrder: 'Bay Order',
        clientInfo: 'Bay Information',
        clientType: 'Bay Type',
        cancel: 'Cancel',
        saveChanges: 'Save Changes',
      },
      shopGameRoundOptionSetting: {
        title: 'Round Option Settings',
        concede: 'Concede',
        holecupPosition: 'Hole Cup Location',
        mulliganCount: 'Mulligan Count',
        swingPlate: 'Swing Plate',
        distanceUnit: 'Distance Unit',
        greenPosition: 'Green Location',
        greenSpeed: 'Green Speed',
        windStrength: 'Wind Speed',
        puttingLine: 'Putting Line',
        bestVideo: 'Best video',
        continuePutting: 'Continue Putting',
        caddyVoice: 'Caddie Voice',
        noPuttMode: 'PUTT SKIP',
        obTeeAndHazardTee: 'OB Tee and Hazard Tee',
        on: 'ON',
        off: 'OFF',
        saveChanges: 'Save Changes',
        shotInfoLocation: 'Shot Information Location',
        side: 'Side',
        bottom: 'Bottom',
        greenHardness: 'Green Hardness',
        guideDistance: 'Guide Distance',
        maxScoreFactor: 'Max Strokes per Hole',
      },
      shopDrivingRangeOptionSetting: {
        title: 'Driving Range Option Management',
        course: 'Course',
        drivingRange1: 'KGOLF',
        drivingRange2: 'ZHANGJIAJIE',
        drivingRange3: 'SENTOSA',
        drivingRange4: 'HIDDEN CASTLE',
        drivingRange5: 'KGOLF2',
        difficulty: 'Difficulty',
        teeHeight: 'Tee Height',
        windStrength: 'Wind Speed',
        distanceUnit: 'Unit of Distance',
        swingPlate: 'Swing Plate',
        ballTrajectory: 'Ball Trajectory',
        fixedCamera: 'Fixed Camera',
        swingVideo: 'Swing Video',
        on: 'ON',
        off: 'OFF',
        saveChanges: 'Save Changes',
      },
      shopClientRealTimeControlOptionSetting: {
        title: 'Bay Real-Time Control Option Settings',
        paymentType: 'Payment Type',
        usageTimeSetting: 'Time',
        usageModeSetting: 'Mode Type',
        noLimit: 'No Limit',
        stroke: 'Stroke',
        drivingRange: 'Driving Range',
        usageContentSetting: 'Content setting',
        availablePlayerCountSetting: 'Number of player setting',
        holeType: 'hole type',
        drivingRangeTime: 'Driving Range usage time',
        saveChanges: 'Save Changes',
        peopleUnit: 'Number of players',
        none: 'None',
        minutes: 'Minutes',
      },
      accountInfoSetting: {
        accountInfo: 'Account Information',
        name: 'Name',
        id: 'ID',
        password: 'Password',
        
        changePassword: 'Change Password',
        newPasswordPlaceholder: 'Enter your new password.',
        cancel: 'Cancel',
        submit: 'Change',
        validation: 'The password must be 4 to 12 characters long and include numbers, lowercase, and uppercase letters.',
        successful: 'Your password has been changed.',
        fail: 'Failed to change the password.'
      },
      clientInfoSetting: {
        clientInfo: 'Client Password Change',
        password: 'Password',
        changePassword: 'Change Password',
        newPasswordPlaceholder: 'Enter your new password.',
        cancel: 'Cancel',
        submit: 'Change',
        validation: 'Password: 4 digits',
        successful: 'The password for all clients at the store has been changed.',
        fail: 'Failed to change the password.'
      },
    },
    scorecard: {
      title: 'Scorecard',
      gameNumbers: 'Round ID',
      gameType: 'Game Type',
      courseName: 'Course Name',
      gameHoleType: 'Hole Type',
      shopName: 'Store Name',
      shopClientName: 'Bay Name',
      startTime: 'Start Time',
      endTime: 'End Time',
      concede: 'Concede',
      holeCupPosition: 'Hole Cup Location',
      mulligan: 'Mulligan',
      greenPosition: 'Green Location',
      greenSpeed: 'Green Speed',
      swingPlate: 'Swing Plate',
      windStrength: 'Wind Speed',
      distanceUnit: 'Distance Unit',
      puttingLine: 'Putting Line',
      bestVideo: 'Best Shot Video',
      caddyVoice: 'Caddie Voice',
      whetherUseObTeeAndHazardTee: 'OB & Hazard Tee Use',
      use: 'Enabled',
      unused: 'Disabled',
      stroke: 'Stroke',
      newPerio: 'New Perio',
      ranking: 'Rank',
      team: 'Team',
      nickname: 'Nickname',
      handicap: 'Handicap',
      close: 'Close',
      alertText1: 'Game in process',
      grade: 'Grade',
      greenHardness: 'Green Hardness',
      guideDistance: 'Guide Distance',
      maxScoreFactor: 'Max Strokes per Hole',
      on: 'ON',
      off: 'OFF',
    },
    alert: {
      comingSoon: 'Coming soon',
      unusualApproach: 'This is an abnormal approach',
      deletePaymentMethodSuccess: 'The payment method has been deleted successfully.',
      deletePaymentMethodFail: 'Failed to delete payment method.',
      shopRecurringPaymentCancelSuccess: 'The subscription payment cancellation has been completed.',
      shopRecurringPaymentCancelFail: 'The subscription payment cancellation has been failed.',
    },
    popup: {
      title: {
        sendMessage: 'Send Message',
        scorecard: 'Scorecard',
        addGuest: 'Add Guest',
        shotCancel: 'Shot Cancel',
        extendedTime: 'Extend Time',
        changeSetting: 'Change Settings',
        courseSelection: 'Course Settings',
        rankingCriteriaGameRoundCount: "What is Game Round Count Ranking?",
        rankingCriteriaBackCount: 'What is the Countback Method?',
        shopTournamentOpenConfirm: 'Confirm Tournament Creation',
        shopTournamentModifyConfirm: 'Confirm Tournament Modification',

        deleteTournamentConfirm: 'Tournament Deletion',
        earlyEndTournamentConfirm: 'Early Tournament End',
        resetAwardsConfirm: 'Reset Awards',
        awardRecipientsSelectionConfirm: 'Confirm Award Recipients Selection',
        tournamentAwardAnnouncementConfirm: 'Confirm Award Announcement',
        contentsItemPayment: 'Content Application',
        callNotification: 'Customer Call Requests',
      },
      button: {
        close: 'Close',
        cancel: 'Cancel',
        confirm: 'Confirm',
        announcement: 'Announcement',
      },
    },
    agreement: {
      terms: 'Business Owner Terms',
      privacy: 'Privacy Policy',
      refund: 'Refund Policy',
      termsText:
          'This agreement defines the terms of system use between K-Golf, the developer and manufacturer of the screen golf system, and the business owner (store operator) who runs a for-profit business using the K-Golf system.\n\n' +
          'Article 1 (Purpose)\n' +
          'These terms and conditions ("Agreement") aim to define the rights, obligations, and responsibilities between the business owner and K-Golf Co., Ltd. ("Company") in relation to the use of services provided by the Company (screen golf service), internet-related services, and web and mobile services.\n\n' +
          'Article 2 (Definitions)\n' +
          '1. "Business Owner" refers to the owner of a business who operates a commercial store using K-Golf products approved by the Company.\n' +
          '2. "K-Golf Store" ("Business Location") refers to a store where the Business Owner has purchased and installed K-Golf products, and the Company has approved service provision.\n' +
          '3. "K-Golf Products" means the screen golf systems developed and produced by K-Golf.\n' +
          '4. "User Customer" refers to a customer who visits the business location, uses K-Golf products, and pays the usage fee according to the business location’s pricing policy.\n' +
          '5. "Billing" means the charges incurred when using games or paid content via K-Golf software.\n' +
          '6. "K-Golf Online Service" refers to all services provided to User Customers using K-Golf products at the business location (e.g., online course access, game records, events).\n' +
          '7. "K-Golf Online Service Fee" refers to the fee paid by User Customers for using the online golf course and is charged per use.\n' +
          '8. "Store Manager" refers to the software provided by the Company for Business Owners to manage K-Golf products online.\n\n' +
          'Article 3 (Game Billing Operation)\n' +
          '1. Billing methods are as follows:\n' +
          '  1) Online course use is billed per game and charged to the Business Owner.\n' +
          '  2) 100 KRW is charged per hole from hole 1 to 18.\n' +
          '  3) If a game is stopped midway, billing is based on the number of holes played.\n' +
          '2. Billing by product type:\n' +
          '  1) Practice C: Only 9-hole 20 courses available, free of charge.\n' +
          '  2) Combo A / Practice B: All content accessible; usage fees are charged per person per hole.\n' +
          '3. Payment methods:\n' +
          '  1) Default: Postpaid automatic bank transfer. Prepaid and overdue payment options available.\n' +
          '  2) The Business Owner must pay the total amount monthly; partial payments are not allowed.\n' +
          '  3) Postpaid: Charges from the previous month (1st–end) are auto-debited on the due date (twice a day).\n' +
          '  4) Prepaid: Payment via transfer or credit card at least 2 days before the due date.\n' +
          '  5) Overdue: Payment made manually after the due date.\n\n' +
          'Article 4 (Payment Method, Arrears Handling, and Product Change)\n' +
          '1. Two methods: Bank transfer or credit card.\n' +
          '2. Arrears:\n' +
          '  1) Services are suspended immediately after overdue.\n' +
          '  2) Daily interest applies from the date of arrears (0.n%).\n' +
          '  3) Service is restored upon payment.\n' +
          '3. Product changes take effect on the 1st of each month.\n\n' +
          'Article 5 (Unspecified Matters and Legal Priority)\n' +
          '1. Unspecified matters follow relevant laws and customs.\n' +
          '2. Consumer protection laws (e.g., E-Commerce Act) take precedence.\n' +
          '3. If individual terms exist, they take priority.\n\n' +
          'Article 6 (Disclaimer)\n' +
          '1. Not liable for force majeure such as natural disasters, war, or telecom outage.\n' +
          '2. Not liable for damages from maintenance or replacement.\n' +
          '3. Not liable for damage caused by store computer error or incorrect data.\n' +
          '4. Not liable for unmet expected profits or data use losses.\n' +
          '5. No obligation for prior review of posted content.\n' +
          '6. No liability for free services except in case of privacy violations.\n\n' +
          'Article 7 (Contract Termination, etc.)\n' +
          '1. In case of mutual termination or sale, prior notice and payment of outstanding amounts required before service recovery.\n' +
          '2. Late payment incurs statutory interest.\n' +
          '3. If partially used, the corresponding amount and costs can be charged.\n\n' +
          'Article 8 (Dispute Resolution)\n' +
          '1. Compensation handling department is operated.\n' +
          '2. Complaints and inquiries are prioritized; if delayed, reasons and schedule are provided.\n\n' +
          'Article 9 (Governing Law and Jurisdiction)\n' +
          '1. Governed by the laws of the Republic of Korea.\n' +
          '2. Jurisdiction follows the Civil Procedure Act.',

      privacyText:
          'Article 1 General Provisions\n' +
          'K-Golf Co., Ltd. ("Company") values the personal information provided by users while using the services offered through the store management site (https://kms.thekgolf.com). We comply with relevant laws (e.g., the Communications Privacy Protection Act, the Act on Promotion of Information and Communications Network Utilization, etc.) and provide a clear explanation of how personal information is collected and used through this Privacy Policy. This policy is subject to revision according to law or internal policy changes.\n\n' +

          'Article 2 Items Collected, Collection Methods, and Purpose of Use\n' +
          '(a) Items Collected\n' +
          '  1) For membership registration and service provision: Name, ID, mobile phone number, address, email (deleted upon withdrawal)\n' +
          '  2) For bank transfer payments: Bank name, account number, account holder (retained for 5 years)\n' +
          '  3) For virtual account: Bank name, depositor name (retained for 5 years)\n' +
          '  4) For credit card payments: Card company, card number, expiration date (retained for 5 years)\n' +
          '  5) For transaction records: IP address, cookies, access logs, usage history (deleted upon withdrawal)\n' +
          '  6) For events/delivery: Name, address, phone number (destroyed after purpose is achieved)\n' +
          '  7) For promotional materials: Name, address, phone number (destroyed after purpose is achieved)\n\n' +
          '(b) Purpose of Use\n' +
          '  1) Contract fulfillment and billing\n' +
          '  2) Member management, identity verification, preventing improper use, handling complaints\n' +
          '  3) New service development, marketing, statistics, advertising\n' +
          '  4) Individual notifications in case of service failures\n\n' +
          '(c) Retention Period\n' +
          '  - Retained during service use; destroyed upon request for deletion or withdrawal\n' +
          '  - Destroyed immediately after the purpose of collection is fulfilled (e.g., for events)\n' +
          '  - Records of users with violations are stored for 1 year from termination\n\n' +
          '(d) Collection Methods\n' +
          '  - Website, documents, fax, phone, bulletin board, email, events, cookie/log tools\n\n' +

          'Article 3 Procedure and Method for Disposal of Personal Information\n' +
          '(a) Disposal Procedure: Stored for a certain period according to internal policies and laws after the purpose is fulfilled, then destroyed.\n' +
          '(b) Disposal Method: Paper documents are shredded or incinerated; electronic files are deleted in an unrecoverable way.\n\n' +

          'Article 4 Provision and Sharing of Personal Information\n' +
          'Personal information will not be shared with third parties without prior consent.\n' +
          'However, exceptions apply in the following cases:\n' +
          '  - If the user has consented\n' +
          '  - For billing, service violation handling, or legal investigations\n\n' +

          'Article 5 Outsourcing of Processing\n' +
          'We outsource some services to professional companies for better service quality. The outsourcing contract specifies legal compliance and responsibility.\n' +
          '  - Outsourced tasks: Credit card payments, bank transfers, SMS → Settlebank\n\n' +

          'Article 6 User Rights\n' +
          'Users and legal representatives can request to view, edit, delete, or withdraw personal information through the website.\n\n' +

          'Article 7 Withdrawal of Consent\n' +
          'Consent (e.g., at sign-up) can be withdrawn immediately by written request, phone, or email.\n\n' +

          'Article 8 Cookie Usage\n' +
          'Cookies are used to provide customized services. Users can allow or block cookies in their browser settings. Blocking cookies may restrict some services.\n\n' +

          'Article 9 Protection Measures\n' +
          '  - Password protection, antivirus software, encryption, firewall systems\n' +
          '  - Limited access to authorized staff with regular training\n\n' +

          'Article 10 Protection of Children’s Information\n' +
          'For users under the age of 14, consent from a legal guardian is required.\n\n' +

          'Article 11 Marketing Information Transmission\n' +
          'Advertisements cannot be sent without explicit consent. If sent, "Advertisement" will be clearly labeled.\n\n' +

          'Article 12 Contact for Inquiries\n' +
          'Data Protection Officer: Haksoo Kim (Admin Division) +82-1577-0564 / kimhs@thekgolf.com\n' +

          'Article 13 Amendments\n' +
          'Effective Date: January 2, 2021',

      refundText:
          'These regulations apply when a consumer requests a refund for pre-paid content passes (e.g., monthly passes, usage passes, seasonal passes) purchased from K-Golf Co., Ltd. or affiliated stores, based on the usage period or count. They are managed in accordance with relevant laws, the Korea Fair Trade Commission’s Consumer Dispute Resolution Standards, and industry practices.\n\n' +

          'Article 1 (Reasons and Standards for Refunds)\n' +
          '1. If the consumer is responsible for the refund request:\n' +
          '  1) Before usage begins:\n' +
          '    - If the refund is requested within 7 days of payment: Full refund without penalty, based on Articles 17 and 18(9) of the E-Commerce Act.\n' +
          '    - If the refund is requested after 7 days: The right to withdraw is forfeited. Post-usage standards apply.\n' +
          '  2) After usage begins:\n' +
          '    - The amount equivalent to the used days or counts (based on the standard unit price) will be deducted and the remaining balance refunded.\n' +
          '    - A 10% cancellation fee (penalty) will be deducted from the remaining balance.\n\n' +

          '2. If the company is responsible for the refund:\n' +
          '  1) Before usage begins: Full refund of the payment amount.\n' +
          '  2) After usage begins: Full refund of the unused remaining amount (no cancellation fee).\n\n' +

          'Article 2 (Refund Procedure)\n' +
          '1. Submit a written request or contact the customer center.\n' +
          '2. If requested within 7 days from the payment date: Immediate full refund.\n' +
          '3. If requested after usage begins: The used amount is deducted and a 10% cancellation fee is applied. The refund will be processed within 7 business days.\n' +
          '4. The affiliated store sends the request to the head office for settlement and refund processing.\n\n' +

          'Article 3 (Refund Calculation Example)\n' +
          'Example: Monthly pass of 100$ with a 30-day usage period\n' +
          '  - If canceled after 10 days of use:\n' +
          '    · Used amount: 10 × 3.3$ = 33$ \n' +
          '    · Remaining balance: 100 – 33 = 67$ \n' +
          '    · Cancellation fee (10%): 6.7$ \n' +
          '    · Refund amount: 60.3$ (approx. 60$)\n\n' +

          'Article 4 (Customer Inquiries)\n' +
          'Refunds and inquiries: Customer Service +82-1577-0564\n\n' +

          'Article 5 (Legal Basis)\n' +
          '· Articles 17 and 18 of the “Act on the Consumer Protection in Electronic Commerce, etc.”\n' +
          '· Article 21 of the Enforcement Decree of the same Act\n' +
          '· “Consumer Dispute Resolution Standards” (KFTC Notice No. 2023-14)'
    },
    tournament: {
      list: {
        tournamentOpen: 'Create Tournament',
        tournamentId: 'Tournament ID',
        title: 'Tournament Name',
        tournamentType: 'Type',
        period: 'Duration',
        participantCount: 'Number of Participants',
        courseCount: 'Number of Courses',
        modify: 'Edit Status',
        etc: 'Actions',
        expires01: 'The new tournament system is scheduled to be updated in July. \nAfter the update, players will be able to select up to four courses for each tournament.',
        expires02: 'For tournaments scheduled before the update, please set the end date no later than September 15, 2024.',

        modifyPossibility: 'Editable',
        modifyImpossibility: 'Non-Editable',
        listDelete: 'Delete',
        earlyTermination: 'End Early',
        awarding: 'Award Prizes',
        awardAnnouncement: 'Award Presentation',
        awardRecipientsView: 'Awards Details',

        statusFilter: {
          all: 'All',
          proceeding: 'In Progress',
          expected: 'Scheduled',
          end: 'Completed',
        },

        popup: {
          deleteTournamentConfirm: {
            text1: 'Are you sure you want to delete the selected tournament?',
            text2: '※ Deleted tournament cannot be restored.',

            requestSuccess: 'The tournament has been deleted.',
            requestFail: 'Failed to delete tournament. \n Please try again',
          },
          earlyEndTournamentConfirm: {
            text1: 'Are you sure you want to end the current tournament based on the current time?',
            text2: '※ Once the tournament is over, you will no longer be able to participate in the tournament.',
            text3: 'However, users who are currently in the tournament can proceed.',

            requestSuccess: 'The tournament ended early.',
            requestFail: 'Failed to end the tournament early. \n Please try again',
          },
        },
      },

      open: {
        tournamentTerm: 'Tournament Policy',
        acceptTerms: 'Agree to Terms',

        participatingStoresSettingAlert: 'Only 10 can be opened.',
        participatingStoresSetting: 'Participating Store Settings',
        addParticipatingStore: 'Add Participating Store',
        country: 'Nation',
        province: 'City / Province',
        city: 'City / County / District',
        participatingStore: 'Participating Store',

        basicSetting: 'Basic Settings',
        tournamentTitle: 'Tournament Name',
        tournamentTitlePlaceholder: 'Enter the tournament name (up to 20 characters in Korean, 40 characters in English)',
        tournamentTitleInvalidMessage: 'Please enter the tournament name (up to 20 characters in Korean, 40 characters in English)',
        tournamentIntroduce: 'Tournament Description',
        tournamentIntroducePlaceholder: 'Provide a brief description of the tournament (up to 100 characters in Korean, 120 characters in English) \n※ If left blank, it will display as "No Description."',
        tournamentIntroduceInvalidMessage: 'Please enter the tournament description within 120 characters.',
        tournamentSummary: 'Tournament Guidelines',
        tournamentParticipantTerms: 'Participant Terms and Conditions',
        tournamentSummaryDefaultValue:
        'Terms and Conditions for K-Golf Tournaments\n' +
            'The K-Golf Tournament is a screen golf competition organized using K-Golf’s programs and equipment. It is hosted by K-Golf headquarters, K-Golf store owners, or representatives of store owner associations.\n' +
            '\n' +
            'Article 1: Eligibility\n' +
            'All members who have officially registered with K-Golf, excluding irregular members, are eligible to participate.\n' +
            'Irregular members and non-members may participate in the tournament, but all records from their rounds will be excluded from rankings, calculations, and awards. (Irregular members refer to those who have been sanctioned or penalized for participating in unauthorized events or possess accounts deemed equivalent to such violations.)\n' +
            '\n' +
            'Article 2: How to Participate\n' +
            'Participants can log in at any K-Golf store, enter tournament mode, select the tournament they wish to join from the list, and play the round.\n' +
            'There is no additional participation fee other than the store’s standard round fee.\n' +
            'Participation is limited to one account per person. If a participant uses another person’s account or multiple accounts, all such participations will be invalidated, and the participant will be excluded from awards.\n' +
            '\n' +
            'Article 3: Award Regulations\n' +
            'After the tournament ends, the final rankings can be checked via the K-Golf app. Violations of the tournament regulations will result in disqualification from awards. (Non-members and store owners are excluded from awards.)\n' +
            'Award conditions vary depending on the tournament organizer and will follow the guidelines announced. Award details may change depending on the progress of the tournament.\n' +
            'If a participant’s contact information (e.g., phone number, address) is incorrect, the organizer may cancel the award at their discretion.\n' +
            'For tournaments organized by stores, K-Golf headquarters does not involve itself in tournament conditions or awards and bears no responsibility for them.\n' +
            'In the case of tied scores, rankings will be determined in the following order: the number of rounds completed, back count, and the starting time of the last round. For multiple-course tournaments, back counts will be calculated using the combined scores of the rounds recorded in the course rankings.\n' +
            '\n' +
            'Article 4: Tournament Regulations\n' +
            'For logged-in participants, scorecard submission and ranking updates are automatic upon round completion.\n' +
            'Only rounds where all 18 holes are completed will be recognized. Incomplete rounds are excluded from rankings and awards.\n' +
            'Participants unable to verify their identity via camera will be disqualified.\n' +
            'The round rules follow the K-Golf program. Conditions such as basic requirements and withdrawals are determined by the organizer.\n' +
            'Pre-announced store tournaments may be canceled or interrupted due to program issues, natural disasters, or other unforeseen circumstances.\n' +
            'In cases where issues arise due to store circumstances (e.g., unstable networks, power outages) rather than service problems, responsibility and resolution lie with the organizer and participant.\n' +
            'A specified number of mulligans may be used to address unavoidable issues. Participants may also use mulligans at their discretion if no issues arise.\n' +
            'Participants may use their own clubs. Organizers may review video footage for verification purposes, and any detected misconduct will result in disqualification. Manipulation of computer data will also lead to disqualification.\n' +
            'Participants must fully understand the pre-announced tournament conditions. Violations may result in disqualification.\n' +
            '\n' +
            'Article 5: Additional Provisions\n' +
            'Participants may be restricted from participating if they refuse to comply with the organizer’s instructions.\n' +
            'As a rule, no objections will be accepted after the tournament ends.\n' +
            'If a participant raises an issue due to a system error, logs will be reviewed to determine whether it is valid.\n' +
            'Videos recorded during the tournament period are used for award verification and are deleted after a certain period.',
        tournamentThumbnail: 'Tournament Thumbnail',

        participationTarget: 'Participant Eligibility',
        participationTargetDescription: 'Select eligible levels for tournament participation',
        addParticipationTarget: 'Add Participant Level',
        participationTargetLimitType: 'Restriction Type',
        participationTargetName: 'Criteria Name',
        participationTargetFullName: 'Participant Distinguished Name',
        participationTargetGender: 'Gender',
        participationTargetBirthYearLimit: 'Birth Year Restriction',
        participationTargetType: 'Eligibility Type',
        participationTargetMinimumBirthYear: 'Minimum Birth Year',
        participationTargetMaximumBirthYear: 'Maximum Birth Year',
        participationTargetBirthYearMessage1: 'Start year cannot be earlier than the specified year.',
        participationTargetBirthYearMessage2: 'End year cannot be later than the specified year.',
        participationTargetTeeBoxTypeSetting: 'Tee Box Location Setting',

        participationGrade: 'Participation level',

        participationConditions: 'Participation conditions',
        participationConditionsDescription: 'Anyone can participate regardless of previous tournament record',
        addParticipationConditions: 'Add Participation conditions',
        participationConditionsLimitType: 'Restriction Classification',
        participationConditionsTournamentList: 'Tournament List',
        participationConditionsRankingsLitmit: 'Ranking Restrictions',
        participationConditionType: 'Participation condition type',
        participationConditionsTournamentTitlePlaceholder: 'Please search for the tournament.',

        participationPeriod: 'Participation Period',

        participatePublic: 'Participation Type',
        participatePublicPlaceholder: 'Password (4 digits)',

        public: 'Public',
        nondisclosure: 'Private',

        courseSetting: 'Course Settings',
        courseCount: 'Number of Courses',
        courseCountUnit: '',
        courseSelection: 'Select Courses',
        courseNumber: 'ID',
        courseTitle: 'Course Name',
        courseType: 'Course Type',
        courseDifficulty: 'Course Difficulty',
        greenDifficulty: 'Green Difficulty',
        longestHole: 'Longest Hole',
        nearpinHole: 'Nearest Pin Hole',
        newPerio: 'New Perio',
        outCourseHole: 'Front Nine',
        inCourseHole: 'Back Nine',

        gameSetting: 'Match Settings',
        difficultyEasy: 'Easy',
        difficultyNormal: 'Normal',
        difficultyHard: 'Difficult',
        difficultyManual: 'Manual',
        courseStartOrder: 'Starting Order',
        courseStartValue1: 'Front Nine > Back Nine',
        courseStartValue2: 'Back Nine > Front Nine',
        userDifficulty: 'User Difficulty',
        swingPlate: 'Swing Plate',
        mulliganCount: 'Mulligan Count',
        windPower: 'Wind Speed',
        holeCupPosition: 'Hole Cup Location',
        greenPosition: 'Green Location',
        concede: 'Concede',
        greenSpeed: 'Green Speed',
        puttingLineCount: 'Putting Line',
        greenHardness : 'Green Hardness',
        teeBox: 'Tee Box ',
        guideDistance: 'Guide Distance',

        participantHandicap: 'Participant Handicap',
        calibrationGrade: 'Calibration by level',
        userGrade: 'Member rating',
        scoreCorrection: 'Score correction',
        calibrationParticipant: 'Score correction for each participant',

        rankingCriteria: 'Ranking Criteria',
        rankingCriteriaDescription1: 'What is the Ranking Criteria?',
        rankingCriteriaDescription2: 'The ranking criteria determine the order in which players are ranked when they have identical scores.',
        rankingCriteriaOne: '1st Priority:',
        rankingCriteriaGameRoundCount: 'Number of Completed Rounds',
        rankingCriteriaGameRoundCountButton: 'What is Ranking by number of games completed',
        rankingCriteriaGameRoundCountDescription: 'When scores are tied, the player who has completed more rounds of 18 holes will be ranked higher.',
        rankingCriteriaTwo: '2nd Priority:',
        rankingCriteriaOrderByGameRoundDesc: 'Countback Calculation',
        rankingCriteriaCountbackDescription: 'The countback method calculates ties based on the sum of scores in the following order: the last 9 holes, the last 6 holes, the last 3 holes, and finally the score on the last hole. This countback calculation is applied only to the cumulative ranking.',
        rankingCriteriaThree: '3rd Priority:',
        rankingCriteriaBackCount: 'Using the Countback Method',
        rankingCriteriaBackCountButton: 'What is the Countback Method?',
        rankingCriteriaLastRoundStartTime: 'Last Round Start Time',
        rankingCriteriaLastRoundStartTimeDescription: 'If the number of completed rounds is also the same, the player who started their last 18-hole round most recently will be ranked higher.',
        rankingCriteriaUse: 'Enabled',
        rankingCriteriaUnused: 'Disabled',

        awardSetting: 'Award Settings',
        addAward: 'Add Award',
        awardName: 'Award Name',
        awardNamePlaceholder: 'Please enter the award name.',
        awardGender: 'Gender',
        awardGenderAll: 'no classification',
        awardItem: 'Award Criteria',
        awardType: 'Award Type',
        awardCourse: 'Course classification',
        awardCourseTotal: 'Course Overall',
        awardRankingType: 'Ranking Type',
        awardSingleRanking: 'Individual Rank',
        awardRanegeRanking: 'Range Rank',
        awardRankingRange: 'Ranking Range',
        awardRankingPlaceholder: 'Please enter a rank.',
        awardRankingRangeText1: 'To',
        awardRankingRangeText2: '',
        awardProduct: 'Award Item',
        awardProductPlaceholder: 'Please enter the prize.',

        whetherLimit: 'Restriction or not',
        unLimit: 'Unrestricted',
        delete: 'Delete',
        all: 'All',
        yearUnit: 'Year',
        yearRangeText1: 'From',
        yearRangeText2: 'Until',

        save: 'Save',
        modify: 'Save Changes',

        navigation: {
          step1: 'Agree to Terms',
          step2: 'Tournament Settings',
          step3: 'Create Tournament',
        },

        popup: {
          courseSelection: {
            title: 'Tournament course selection',
            courseSearch: 'Search Course',
            courseSearchPlaceholder: 'Enter course name',
            selection: 'Select',
            save: 'Save',
            cancel: 'Close',

            message1: 'You can no longer choose a course',
            message2: 'Please select a course',
          },
          rankingCriteriaGameRoundCount: {
            text1: 'The ability to register users with more records of participating in held Tournament and completing the course in the top ranking',
            cancel: 'Close',
          },
          rankingCriteriaBackCount: {
            text1: "The user's score is divided into first half/second half holes.",
            text2: '※ For the first and second half holes, the first nine holes are the first half, and the last nine holes are the second half.',
            text3: 'Just because the hole number is 10, it does not become a second half hole.',
            text4: 'The user with a better overall score in the second half (9 holes) will be ranked higher.',
            text5: '- 9 holes from the last hole played',
            text6: 'A user with a better overall score of the last 6 holes is ranked higher.',
            text7: '- 6 holes from the last hole hit',
            text8: 'A user with a better overall score of the last 3 holes is ranked higher.',
            text9: '- 3 holes from the last hole hit',
            text10: 'By comparing the scores of the last hole hit, the user with the better score is ranked higher.',
            cancel: 'Close',
          },
          shopTournamentOpenConfirm: {
            text1: 'Are you sure you want to create the tournament with the entered details?',
            text2: 'Once created, the tournament can be viewed and edited in the tournament list.',

            title: 'The tournament name is already in use. Please enter a different tournament name.',

            requestSuccess: 'The store tournament has been created.',
            requestFail: 'An error occurred during the creation of the store tournament. \nPlease try again.',
          },
          shopTournamentModifyConfirm: {
            text1: 'Would you like to update the tournament with the current details?',

            title: 'The tournament name is already in use. Please enter a different tournament name.',

            requestSuccess: 'The store tournament has been edited.',
            requestFail: 'An error occurred while updating the store tournament. \nPlease try again.',
          },
        },

        alert: {
          message1: 'Please enter at least one participant type to proceed with participation.',
          message2: 'Handicap values must be between -99 and 99.',
          message3: 'The tournament start time must be set at least 24 hours from the current time.',
          message4: 'The tournament period can be configured for up to one year.',
          message5: 'Please complete the course settings before proceeding.',
          message6: 'Please complete the award settings before proceeding.',
          message7: 'Please ensure the starting rank is set to a lower value.',
          message8: 'Password must contain 4 digits',
          message9: 'There is an error in the ranking configuration. Please review.\nExample: Values like -1 and 0 are not allowed.',
          message10: 'Please enter a name for the award.',
          message11: 'Please enter a name for the tournament.',
          message12: 'Please specify the award items for the additional award details.',
          message13: 'Please verify the number of courses and select a course.',
        },

        isParticipationGrade: 'Rating Settings',
        participationGradeText1:
          'When enabled, <img src="/images/icon/ui_icon_grade_0_0.png" alt="grade" class="icon_grade" /><img src="/images/icon/ui_icon_grade_1_0.png" alt="grade" class="icon_grade" /> members with these ratings are not allowed to participate in the tournament.',
        participationGradeSelectTitle: 'Participant Eligibility',
        participationGradeSelectNoUse: 'No restrictions',
        participationGrade2: 'Bronze',
        participationGrade3: 'Silver',
        participationGrade4: 'Gold',
        participationGrade5: 'Platinum',
        participationGrade6: 'Diamond',
        participationKHandiText6: '-0.1 or lower (Scratch Golfers)',
        participationKHandiText5: '0.0 to +7.9 (Single-digit Golfers)',
        participationKHandiText4: '+8.0 to +17.9 (80s Golfers)',
        participationKHandiText3: '+18.0 to 27.9 (90s Golfers)',
        participationKHandiText2: '+28.0 and above (100s Golfers)',
        participationGradeText6_3: 'Top 10% of Diamond Grade',
        participationGradeText6_2: 'Above 10% to Top 30% of Diamond Grade',
        participationGradeText6_1: 'Above Top 30% of Diamond Grade',
        participationGradeText5_3: 'Handicap 0.0 to 2.0',
        participationGradeText5_2: 'Handicap 2.1 to 5.0',
        participationGradeText5_1: 'Handicap 5.1 to 7.9',
        participationGradeText4_3: 'Handicap 8.0 to 10.0',
        participationGradeText4_2: 'Handicap 10.1 to 14.0',
        participationGradeText4_1: 'Handicap 14.1 to 17.9',
        participationGradeText3_3: 'Handicap 18.0 to 20.0',
        participationGradeText3_2: 'Handicap 20.1 to 24.0',
        participationGradeText3_1: 'Handicap 24.1 to 27.9',
        participationGradeText2_3: 'Handicap 28.0 to 38.0',
        participationGradeText2_2: 'Handicap 38.1 to 48.0',
        participationGradeText2_1: 'Handicap 48.1 and above',
        calibration: 'Score Adjustment',
        kHandi: 'K-Handicap',
        criteria: 'Criteria',
        notAllowed: 'Not Eligible',
      },

      details: {
        tab: {
          summary: 'Tournament Overview',
          information: 'Tournament Information',
          ranking: 'Tournament Ranking',
          award: 'Tournament Awards',
          awardHistory: 'Award History',
          participantTerms: 'Participant Terms and Conditions',
          participatingStoresList: 'List of participating stores',
        },

        information: {
          introduce: 'Description',

          tournamentPeriod: 'Duration',
          participatePublic:'Participation Type',

          participationTarget: 'Participant Eligibility',
          participationNoLimit: 'No restrictions',
          participationTargetName: 'Distinguished Name',
          participationTargetFullName: 'Participant Distinguished Name',
          participationTargetMinimumBirthYear: 'Minimum year of birth',
          participationTargetMaximumBirthYear: 'Maximum year of birth',
          participationTargetTeeBoxSetting: 'Set tee box',

          participationGrade: 'Participation level',
          gradeParticipationAvailability: 'Participation availability',
          participationPossible: 'Participation possible',
          unableParticipate: 'Unable to participate',

          participationConditions: 'Participation conditions',
          participationConditionTournamentName: 'Tournament Name',
          participationConditionRankingLimit: 'Ranking restrictions',

          tournamentCourse: 'Courses',
          courseNumber: 'No.',
          courseName: 'Course Name',
          courseLongest: 'Longest',
          courseNearpin: 'Near pin',
          sinperioExclusionHall: 'Holes Excluding New Perio Rules',

          userDifficulty: 'User Difficulty',
          swingPlate: 'Swing Plate',
          mulliganCount: 'Mulligan Count',
          windPower: 'Wind Speed',
          holeCupPosition: 'Hole Cup Location',
          greenPosition: 'Green Location',
          concede: 'Concede',
          greenSpeed: 'Green Speed',
          puttingLineCount: 'Putting Line',
          teeBox: 'Tee Box',
          greenHardness: 'Green Hardness',
          calibrationGrade: 'Calibration by Level',
          guideDistance: 'Guide Distance',

          calibrationParticipant: 'Handicap',

          awardItem: 'Award Category',
          awardName: 'Award Name',
          awardType: 'Award Type',
          awardCourse: 'Course classification',
          awardRankingType: 'Ranking Type',
          awardSingleRanking: 'Individual Rank',
          awardRanegeRanking: 'Range Rank',
          awardRankingRange: 'Ranking Range',
          awardRankingUnit: '',
          awardProduct: 'Award Item',
          awardNone: 'None',
          awardAll: 'Overall',

          awardAnnouncement: 'Announce Winners',
          scoreCorrection: 'Score correction',
          genderNoLimit: 'irrelevant',
          participationGradeTitle: 'Participation target and correction information',
        },

        participatingStoresList: {
          country: 'Nation',
          province: 'City / Province',
          city: 'City / County / District',
          participatingStore: 'Participating Store',
          all: 'All',
        },

        ranking: {
          courseTotalScore: 'Total score',
          searchTextBoxPlaceholder: 'Please enter the nickname',

          allRanking: 'Overall Rank',
          allRankingOption1: 'Highest to Lowest',
          allRankingOption2: 'Lowest to Highest',
          allRankingOptionReset: 'Reset',

          genderRanking: 'Gender Rank',
          genderRankingOption1: 'Females Only',
          genderRankingOption2: 'Males Only',
          genderRankingOptionAll: 'All',

          nickname: 'Nickname',
          participationCount: 'Participation Count',
          teeBoxLocation: 'Tee Box Location',
          totalDistance: 'Total Distance (m)',
          remainDistance: 'Remaining Distance (m)',
          recordTime: 'Achievement Time',
          lastRoundStartTime: 'Last Round Start Time',
          newPerioScoreRecord: '12-Hole Score',
          finalScore: 'Final Score',
          birdieCount: 'Birdie Count',
          eagleCount: 'Eagle Count',
          courseName: 'Course Name',
          holeNumber: 'Hole Number',
          courseDistance: 'Total Distance',
          totalParticipationCount: 'Total Participation Count',
          gradeRankingOption1: 'Highest to Lowest',
          gradeRankingOption2: 'Lowest to Highest',
          handicap: 'Handicap',
        },

        awardRanking: {
          allChoice: 'Select All',
          awardConfirmation: 'Award Confirmed',
          resetAwards: 'Reset Awards',
          awardRecipientsSelection: 'Select Winners',

          courseScore: 'Course Score',
          handicap: 'Handicap',
          additionalHandicap: 'Additional Handicap',
          adjustmentResult: 'Adjustment Result',
          adjustmentSynthesis: 'Adjustment Synthesis',
          finalScore: 'Final Score',
          courseOverall: 'Course Overall',
          swingVideo: 'Swing Video',
          videoPlay: 'Play Video',

          alert: {
            message1: 'Additional handicap can only be entered as a number between -99 and 99',
          },
        },

        awardHistory: {
          rankingUnit: ' Place',

          ranking: 'Rank',
          nickname: 'Nickname',
          record: 'Record',
          recordTime: 'Achievement Time',
          totalParticipationCount: 'Participation Count',
          courseName: 'Course Name',
          holeNumber: 'Hole Number',
        },

        course: 'Course',
        summation: 'Total',
        gender: 'Gender',
        grade: 'Staring Grade',
        startGrade: 'Starting Grade',
        lastGrade: 'Final Grade',
        handicapGrade: 'Grade',
        storeUse: 'Store used',
        public: 'Public',
        nondisclosure: 'Private',

        alert: {
          message1: 'Access is only possible 24 hours after the end the tournament',
          message2: 'After selecting the tournament winners, you can view the award details',
        },

        popup: {
          resetTournamentAwardsConfirm: {
            text1: 'Do you want to proceed with the initialization of the award?',
            text2: 'As you proceed with the award initialization, all additional handicaps and award confirmation currently registered will be initialized.',

            requestSuccess: 'All award details have been initialized.',
            requestFail: 'Failed to initialize award details. \nPlease try again.',
          },

          tournamentAwardRecipientsSelectionConfirm: {
            text1: 'Would you like to select the winners based on the currently registered award confirmation?',
            text2: 'You can check the registered contents on the award details page.',
            text3: 'Once the winners have been announced, the rankings cannot be changed. ',
            text4: 'To modify the rankings, you must ‘Initialize awards’ before making any adjustments.',

            requestSuccess: 'The winner selection has been completed. \nThe winner can be found on the award details page.',
            requestFail: 'Winner selection failed. \nPlease try again.',
          },

          tournamentAwardAnnouncementConfirm: {
            text1: 'Once you announce the winner, you can no longer modify the winner.',
            text2: 'Would you like to proceed with the announcement of the winner?',

            requestSuccess: 'The announcement of the winner has been completed.',
            requestFail: 'The announcement of the winner failed.',
          },
        },
      },

      awardItem: {
        Score: 'Score',
        Longest: 'Longest',
        Nearpin: 'Near pin',
        HoleInOne: 'Hole-in-One',
        CourseRoundPlayCount: 'Number of rounds',
      },
      awardType: {
        Stroke: 'Stroke',
        NewPerio: 'New perio',
        BirdieCount: 'Number of birdie',
        EagleCount: 'Number of eagles',
      },
    },
    control: {
      image: {
        delete: 'Delete',
        fileSelect: 'Select File',
      },
    },
    contentsItem: {
      info: {
        prevItem: 'Previous trade information',
        prevItemText: 'This content ticket is no longer available for purchase. <br/>If you would like to purchase it, please contact the service operation team.',
        itemText: 'This product will be automatically activated upon purchase.',
        alertMsgTitle: 'Content Usage Guide',
        alertMsgSubTitle: 'Current Ticket Status',
        alertMsgUser: 'Hello, {user}.',
        paymentMsg: 'Purchased content tickets are applied as follows:\n',
        paymentTitle: 'Select a Payment Method',
      },
      button: {
        payment: 'GO TO BUY',
        purchase: 'BUY',
        rePurchase: 'BUY AGAIN',
        creditCard: 'Credit Card',
        cash: 'Cash',
        paypal: 'PayPal',
      },
      shopSupplyItem: {
        salesCode:'Material Code'
      },
      1010110110: {
        title: 'Content Ticket (Period)',
        icon: '/itemImage/ui_icon_period.png',
        unit: 'DAYS',
        itemInfo: 'Store Device',
        itemDescription: 'This period-based content ticket allows you to operate the service and access game content for {count} days.',
        itemPayment: 'An additional {count} days have been added, allowing you to use the content for a total of {newCount} days.',
        alertMsg: 'Your store’s period-based content ticket will run out in {count} days. Please purchase a new pass to ensure uninterrupted service.',
        alertMsgNone: 'Your store’s period-based content ticket has expired. \nWithout an active ticket, you won’t be able to start new games. \nPlease visit the Shop to purchase a new period-based content ticket.',      
      },
      1010120110: {
        title: 'Content Ticket (Hole)',
        icon: '/itemImage/ui_icon_round.png',
        unit: 'HOLES',
        itemDescription: 'This hole-based content ticket allows you to operate the service and access game content for a total of {count} holes.',
        itemPayment: 'An additional {count} holes have been added, allowing for a total of {newCount} holes of content access.',
        alertMsg: 'Your store’s hole-based content ticket has {count} holes remaining. Please purchase a new ticket to maintain smooth access to content.',
        alertMsgNone: 'Your store’s hole-based content ticket has only {count} holes left. \nIf the remaining holes fall below {round}, you won’t be able to start new games. \nPlease visit the Shop to purchase a new hole-based content ticket.',
      },
      alertMsg: {
        all: 'Your store’s time-based ticket will expire in {day} days, and the hole-based ticket will run out after {count} more holes. To avoid interruptions, please purchase new time-based and hole-based content tickets.',
        allNone: 'Your store’s time-based ticket is down to {day} days, and the hole-based ticket is below {round} holes. \nIf you do not renew your passes, new games cannot be started. \nPlease visit the Shop to purchase additional tickets.',
      },
      // 소모품 구매
      51101511111011: {
        title: 'Mat BGS Type Stance Mat',
        icon: '/itemImage/KGFMAT001012.jpg',
        unit: 'ea',
        itemDescription: 'Stance Mat with rubber base included, size 1100x1300mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '100061',
      },
      51101511111012: {
        title: 'Mat BGS Type (Left/Right) Fairway Mat Set',
        icon: '/itemImage/KGFMAT001013.jpg',
        unit: 'set',
        itemDescription: 'All-in-one mat set with fairway, rough, bunker, and rubber base, 600x1300mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '100062',
      },
      51101511111013: {
        title: 'Mat BGS Type Cut-Out Fairway Mat',
        icon: '/itemImage/KGFMAT002015.jpg',
        unit: 'ea',
        itemDescription: 'Fairway mat with rough and bunker cut-outs, Velcro bottom, 600x1300mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '100081',
      },
      51101511111014: {
        title: 'Mat BGS Type Fairway Mat',
        icon: '/itemImage/KGFMAT002016.jpg',
        unit: 'ea',
        itemDescription: 'Fairway mat with top and two-tone turf, size 370x1300mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '100082',
      },
      51101511111015: {
        title: 'Mat BGS Type Rubber base',
        icon: '/itemImage/700004.jpg',
        unit: 'ea',
        itemDescription: 'Rubber base with cut-outs for bunker and rough, size 600x1300mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '100073',
      },
      51101511111016: {
        title: 'Mat BGS Type Rough Mat',
        icon: '/itemImage/KGFMAT002001.jpg',
        unit: 'ea',
        itemDescription: 'Rough Mat with velcro on bottom, size 400x230mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '100067',
      },
      51101511111017: {
        title: 'Mat BGS Type Grey Bunker Mat',
        icon: '/itemImage/KGFMAT002017.jpg',
        unit: 'ea',
        itemDescription: 'Gray Bunker Mat with velcro on bottom, size 400x230mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '100083',
      },
      51101511111018: {
        title: 'Mat BGS Type Silver Brush Bunker Mat',
        icon: '/itemImage/KGFMAT001011.jpg',
        unit: 'ea',
        itemDescription: 'Silver Brush Bunker Mat with Velcro on steel bottom surface, size 400x230mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '100060',
      },
      51101512111011: {
        title: 'Mat KDR Type Stance Mat',
        icon: '/itemImage/KGFMAT001015.jpg',
        unit: 'ea',
        itemDescription: 'Stance Mat with rubber base, size 1000 x 1000mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '100064',
      },
      51101512111012: {
        title: 'Mat KDR Type Fairway Mat',
        icon: '/itemImage/KGFMAT001017.jpg',
        unit: 'ea',
        itemDescription: 'Fairway Mat with rubber base and two-tone turf, size 500x1000mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '100066',
      },
      51101513111011: {
        title: 'Auto Tee Type  Auto Tee up System',
        icon: '/itemImage/100175.jpg',
        unit: 'ea',
        itemDescription: 'Built-in auto tee-up system set with integrated floor keypad included.<br />* You can check the order status in the payment management menu.',
        salesCode: '100175',
      },
      51101514111012: {
        title: 'Consumables Type Rubber Tee',
        icon: '/itemImage/100187.jpg',
        unit: 'ea',
        itemDescription: 'Rubber Tee, (JE)<br />* You can check the order status in the payment management menu.',
        salesCode: '100187',
      },
      51101514111013: {
        title: 'Consumables Type Rubber Tee (Moving Swing Plate)',
        icon: '/itemImage/100188.jpg',
        unit: 'ea',
        itemDescription: 'Rubber tee for swing plate, compatible with JE auto tee-up system.<br />* You can check the order status in the payment management menu.',
        salesCode: '100188',
      },
      51101517700001: {
        title: 'Mat BGS Type Fairway Mat',
        icon: '/itemImage/700001.jpg',
        unit: 'ea',
        itemDescription: 'Fairway mat with two-tone turf, Velcro bottom, size 370x1040mm<br />* You can check the order status in the payment management menu.',
        salesCode: '700001',
      },
      51101517700002: {
        title: 'Mat BGS Type Fairway Extension Mat 1',
        icon: '/itemImage/700002.jpg',
        unit: 'ea',
        itemDescription: 'Extension panel for fairway mat. Velcro bottom. 230x240mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '700002',
      },
      51101517700003: {
        title: 'Mat BGS Type Fairway Extension Mat 2',
        icon: '/itemImage/700003.jpg',
        unit: 'ea',
        itemDescription: 'Extension panel for fairway mat. Velcro bottom. 260×600mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '700003',
      },
      51101517700004: {
        title: 'Mat BGS Type Fairway Mat Rubber base',
        icon: '/itemImage/700004.jpg',
        unit: 'ea',
        itemDescription: 'Rubber base for fairway set, Velcro top, size 600x1300mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '700004',
      },
      51101517700005: {
        title: 'Mat BGS Type Rough Mat',
        icon: '/itemImage/700005.jpg',
        unit: 'ea',
        itemDescription: 'Rough Mat with Velcro bottom, size 400x230mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '700005',
      },
      51101517700007: {
        title: 'Mat BGS Type Stance Mat',
        icon: '/itemImage/700007.jpg',
        unit: 'ea',
        itemDescription: 'Stance Mat with rubber  bottom, size 1100x1300mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '700007',
      },
      51101517700009: {
        title: 'Mat BGS Type Fairway Set (Right Hand)',
        icon: '/itemImage/700009.jpg',
        unit: 'ea',
        itemDescription: 'Right-Handed all-in-one mat set with fairway, rough, bunker, and rubber base, 600x1300mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '700009',
      },
      51101517700010: {
        title: 'Mat BGS Type Fairway Set (Left Hand)',
        icon: '/itemImage/700010.jpg',
        unit: 'ea',
        itemDescription: 'Left-Handed all-in-one mat set with fairway, rough, bunker, and rubber base, 600x1300mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '700010',
      },
      51101517100175: {
        title: 'Auto Tee Type Auto Tee up System(Right Hand)',
        icon: '/itemImage/100175.jpg',
        unit: 'ea',
        itemDescription: 'Right-Handed built-in auto tee-up system set with integrated floor keypad included.<br />* You can check the order status in the payment management menu.',
        salesCode: '100175',
      },
      51101517100176: {
        title: 'Auto Tee Type Auto Tee up System (Left Hand)',
        icon: '/itemImage/100176.jpg',
        unit: 'ea',
        itemDescription: 'Left-Handed Built-in auto tee-up system set with integrated floor keypad included.<br />* You can check the order status in the payment management menu.',
        salesCode: '100176',
      },
      51101517100222: {
        title: 'Mat BGS Type Bunker Mat',
        icon: '/itemImage/100222.jpg',
        unit: 'ea',
        itemDescription: 'Brush Bunker Mat on steel bottom surface with Velcro, size 400x230mm. <br />* You can check the order status in the payment management menu.',
        salesCode: '100222',
      },
      51101514111011: {
        title: 'Consumables Type Rubber Tee',
        icon: '/itemImage/100186.jpg',
        unit: 'ea',
        itemDescription: 'Rubber Tee, (CT&G)<br />* You can check the order status in the payment management menu.',
        salesCode: '100186',
      },
      51101514111014: {
        title: 'Consumables Type Marking Golf Balls',
        icon: '/itemImage/KGFBAL001001.jpg',
        unit: 'box',
        itemDescription: 'Marked with 4-dot pattern, 1 box includes 300 balls.<br />* You can check the order status in the payment management menu.',
        salesCode: '100166',
      },

    },
  },
};
